module.exports = __webpack_public_path__ + "static/media/3.4d2dcd99.webp";